import Field from '@/atoms/Field'

import priceForm from '../content/priceForm'
import useFieldsetState from '../functions/useFieldsetState'
import { FieldsetProps } from '../ts'

function Fieldset({ range, max }: FieldsetProps) {
  const { handleBlur, handleChange } = useFieldsetState(range, max)

  return (
    <form>
      <fieldset className="flex items-start mb-10 space-x-12">
        {priceForm.map(({ label, inputProps }, index) => (
          <Field key={inputProps.id} label={label}>
            <div className="relative">
              <Field.Input
                className="pr-5"
                {...inputProps}
                value={range[index]}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <span className="absolute text-sm transform -translate-y-1/2 top-1/2 right-2 text-gray-50">
                zł
              </span>
            </div>
          </Field>
        ))}
      </fieldset>
    </form>
  )
}

export default Fieldset
